import { z } from "zod";
import { isoDateStringSchema, timestampsSchema } from "./common";
import { listQueryBaseSchema, queryBoolean } from "./list-query";

export const couponDtoSchema = z
  .object({
    id: z.string().uuid(),
    code: z.string(),
    disscount: z.string(),
    type: z.number().int(),
    startDate: z.string(),
    endDate: z.string(),
    isPrivate: z.boolean(),
    activityIds: z.array(z.number().int()),
  })
  .extend(timestampsSchema.shape);
export type CouponDTO = z.infer<typeof couponDtoSchema>;

export const couponUpsertSchema = z
  .object({
    code: z.string().min(1),
    disscount: z.string().regex(/^\d+(\.\d+)?$/),
    type: z.number().int(),
    startDate: isoDateStringSchema,
    endDate: isoDateStringSchema,
    isPrivate: z.boolean().default(false),
    activityIds: z.array(z.number().int().positive()).default([]),
  })
  .refine((v) => v.endDate >= v.startDate, {
    path: ["endDate"],
    message: "endDate must be >= startDate",
  });
export type CouponUpsertInput = z.infer<typeof couponUpsertSchema>;

export const couponsListQuerySchema = listQueryBaseSchema.extend({
  type: z.coerce.number().int().optional(),
  isPrivate: queryBoolean(),
  activeOn: isoDateStringSchema.optional(),
});
export type CouponsListQuery = z.infer<typeof couponsListQuerySchema>;
